import React, {Component} from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import actions from '../../actions/actions';
import BookWidget from '../BookWidget/BookWidget';
import {EdapProvider} from '@homeaway/react-event-tracking';

function mapStateToProps(state) {
    // Each container component will likely only pull in the state that
    // it cares about. Doing so will eliminate unnecessary rerenders.
    return state;
}

function mapDispatchToProps(dispatch) {
    return {actions: bindActionCreators(actions, dispatch), dispatch};
}

const defaultFields = {eventcategory: 'book now widget'};

@connect(mapStateToProps, mapDispatchToProps)
class Page1Container extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        return (
            <EdapProvider fields={defaultFields}>
                <BookWidget {...this.props}/>
            </EdapProvider>
        );
    }
}

export default Page1Container;
